import { SettingsTranslationType } from "../../features/settings.types";

export const settings: SettingsTranslationType = {
  settings: {
    title: "Einstellungen",
    aiProvider: {
      label: "KI-Anbieter",
      select: "Anbieter auswählen",
      description: "Wählen Sie den KI-Anbieter für die Geschichtengenerierung",
      updateSuccess: "KI-Anbieter Aktualisiert",
      updateSuccessDesc: "Ihre KI-Anbieter-Präferenz wurde gespeichert",
      updateError: "Aktualisierung Fehlgeschlagen",
      updateErrorDesc: "Aktualisierung des KI-Anbieters fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    language: {
      label: "Sprache",
      description: "Wählen Sie Ihre bevorzugte Sprache"
    },
    subscription: {
      title: "Abonnement",
      currentPlan: "Aktueller Plan",
      freeTier: "Kostenlos",
      basicTier: "Basic",
      premiumTier: "Premium",
      status: "Status",
      renewalDate: "Verlängerungsdatum",
      upgradePlan: "Plan Upgraden",
      managePlan: "Plan Verwalten",
      cancelPlan: "Plan Kündigen",
      features: "Funktionen",
      billingCycle: "Abrechnungszyklus",
      monthlyLabel: "Monatlich",
      yearlyLabel: "Jährlich",
      priceUnits: {
        month: "Monat",
        year: "Jahr"
      },
      tiers: {
        free: {
          name: "Kostenlos",
          description: "Grundlegende Funktionen für den Einstieg",
          price: "Kostenlos"
        },
        basic: {
          name: "Basic",
          description: "Erweiterte Funktionen für Hobby-Autoren",
          price: {
            monthly: "€9.99/Monat",
            yearly: "€99/Jahr"
          }
        },
        premium: {
          name: "Premium",
          description: "Vollständiger Zugriff für professionelle Autoren",
          price: {
            monthly: "€19.99/Monat",
            yearly: "€199/Jahr"
          }
        }
      },
      browseCharacters: "Charaktere Durchsuchen",
      upgradeToBrowse: "Upgrade, um Ihre Charaktersammlung zu durchsuchen",
      upgradeToMakePublic: "Upgrade, um Charaktere öffentlich zu machen",
      upgradeRequired: "Upgrade Erforderlich",
      upgradeToBrowseDescription: "Upgraden Sie Ihr Konto, um Ihre Charaktersammlung zu durchsuchen und wiederzuverwenden.",
      upgradeToMakePublicDescription: "Upgraden Sie Ihr Konto, um Charaktere öffentlich mit anderen Benutzern zu teilen.",
      unlockFeatures: "Schalten Sie Premium-Funktionen mit einem Abonnement frei",
      upgradeNow: "Jetzt Upgraden",
      unlockAiTitleGeneration: "KI-Titelgenerierung Freischalten",      
      upgradeForCharaterAccess: "Upgrade, um auf die Charakterverwaltung zuzugreifen",
      upgradeForStatsAccess: "Upgrade, um auf Statistiken und Abzeichen zuzugreifen",
      upgradeForAccess: "Upgrade, um auf diese Funktion zuzugreifen",
      upgradeForAiTitleDescription: "Upgraden Sie auf den Basic-Plan, um Zugriff auf KI-gestützte Titelgenerierung zu erhalten und kreative Vorschläge basierend auf den Themen, Charakteren und Einstellungen Ihrer Geschichte zu bekommen.",
      generateTitlesFeature: "Generieren Sie sofort einzigartige Titel",
      aiTitleGenerationPremium: "KI-Titelgenerierung ist im Basic-Plan verfügbar",
      unlockGenre: "Upgrade, um dieses Genre freizuschalten",
      unlockCustomGenres: "Benutzerdefinierte Genres Freischalten",
      upgradeForCustomGenresDescription: "Upgraden Sie auf den Basic-Plan, um benutzerdefinierte Genres zu erstellen und Ihre Geschichten einzigartiger zu gestalten.",
      addCustomGenresFeature: "Fügen Sie unbegrenzt benutzerdefinierte Genres hinzu",
      unlockEnvironment: "Upgrade, um diese Umgebung freizuschalten",
      upgradeForCustomEnvironments: "Upgrade auf TaleCraft Basic, um benutzerdefinierte Umgebungen hinzuzufügen",
      unlockCustomEnvironments: "Benutzerdefinierte Umgebungen Freischalten",
      upgradeForCustomEnvironmentsDescription: "Upgraden Sie auf den Basic-Plan, um benutzerdefinierte Umgebungen zu erstellen und Ihre Geschichten einzigartiger zu gestalten.",
      addCustomEnvironmentsFeature: "Fügen Sie unbegrenzt benutzerdefinierte Umgebungen hinzu",
      unlockTheme: "Upgrade, um dieses Thema freizuschalten",
      upgradeForCustomThemes: "Upgrade auf TaleCraft Basic, um benutzerdefinierte Themen hinzuzufügen",
      unlockCustomThemes: "Benutzerdefinierte Themen Freischalten",
      upgradeForCustomThemesDescription: "Upgraden Sie auf den Basic-Plan, um benutzerdefinierte Themen zu erstellen und Ihre Geschichten einzigartiger zu gestalten.",
      addCustomThemesFeature: "Fügen Sie unbegrenzt benutzerdefinierte Themen hinzu",
      unlockStoryLength: "Upgrade, um diese Geschichtenlänge freizuschalten",
      upgradeForPremiumLengths: "Upgrade auf TaleCraft Basic, um Zugriff auf längere Geschichten zu erhalten",
      unlockPremiumLengths: "Premium-Geschichtenlängen Freischalten",
      upgradeForPremiumLengthsDescription: "Upgraden Sie auf den Premium-Plan, um längere Geschichten zu erstellen und Ihre Erzählungen detaillierter zu entwickeln.",
      longStoriesFeature: "Erstellen Sie Geschichten ohne Längenbeschränkungen",
      avatarGenerator: {
        upgradeRequired: "Upgrade Erforderlich",
        upgradeDescription: "Upgraden Sie Ihr Konto, um Charakter-Avatare zu generieren.",
        premiumFeature: "Generieren Sie benutzerdefinierte Charakter-Avatare mit einem Premium-Abonnement",
        upgradeNow: "Jetzt Upgraden",
        upgradeTooltip: "Upgrade, um Charakter-Avatare zu generieren"
      },
      planComparison: {
        chooseYourPlan: "Wählen Sie den Plan, der am besten zu Ihnen passt",
        price: "Preis",
        features: "Funktionen",
        talecraftBasic: "TaleCraft Basic",
        talecraftPremium: "TaleCraft Premium",
        savePercentage: "Sparen Sie 17%",
        currentPlanLabel: "Aktueller Plan:",
        processing: "Wird bearbeitet...",
        downgradeToBasic: "Herabstufen auf TaleCraft Basic",
        downgradeToFree: "Herabstufen auf den kostenlosen Plan",
        upgradeToBasic: "Upgrade auf TaleCraft Basic",
        upgradeToPremium: "Upgrade auf TaleCraft Premium",        
        downgradingTo: "Herabstufen auf",
        effectiveOn: "Wirksam ab",
        nextBillingDate: "Nächster Abrechnungszeitraum",
        featureItems: {
          dailyStoryLimit: "Tägliches Geschichtenlimit",
          aiStoryGeneration: "KI-Geschichtengenerierung",
          customResponses: "Angepasste Antworten",
          aiTitleSuggestion: "KI-Titelvorschläge",
          customStorySelection: "Benutzerdefinierte Geschichtenauswahl",
          publicSharing: "Öffentliches Teilen",
          characterManagement: "Charakterverwaltung",
          aiProviderSelection: "KI-Anbieterauswahl",
          statsAndBadges: "Statistiken & Abzeichen/Rangliste",
          badgeRewards: "Abzeichenbelohnungen",
          naturalStoryLength: "Natürliche Geschichtenlänge",
          sequelsAndExtract: "Fortsetzungen & Charakterextraktion",
          characterAvatar: "Charakter-Avatar",
          earlyAccessFeatures: "Frühzugriff auf Funktionen"
        },
        limits: {
          perDay: "/Tag",
          unlimited: "Unbegrenzt"
        }
      }
    },
    profile: {
      displayName: {
        label: "Anzeigename",
        placeholder: "Geben Sie Ihren Anzeigenamen ein",
        updateButton: "Namen Aktualisieren",
        helpText: "Wählen Sie einen eindeutigen Anzeigenamen für Ihr Profil"
      },
      inviteFriends: {
        label: "Freunde Einladen",
        button: "Freunde Einladen",
        dialogTitle: "Einladung Teilen",
        dialogDescription: "Laden Sie Ihre Freunde ein, sich Ihrer Erzählreise anzuschließen. Teilen Sie Ihren einzigartigen Einladungslink oder nutzen Sie soziale Medien.",
        copySuccess: {
          title: "Link kopiert!",
          description: "Der Empfehlungslink wurde in Ihre Zwischenablage kopiert."
        },
        copyFailure: {
          title: "Kopieren fehlgeschlagen",
          description: "Bitte versuchen Sie, den Link manuell zu kopieren."
        },
        shareMessage: "Begleite mich auf unserem Erzählabenteuer! Erstelle und teile tolle Geschichten gemeinsam.",
        socialPlatforms: {
          facebook: "Facebook",
          X: "X",
          linkedin: "LinkedIn",
        }
      },
      upgradeDialog: {
        title: "Upgrade Erforderlich",
        aiProviderDescription: "Upgrade, um einen KI-Anbieter auszuwählen.",
        unlockProviderSelection: "Schalten Sie die KI-Anbieterauswahl mit einem Abonnement frei"
      }
    },
    issues: {
      title: "Problem melden",
      description: "Haben Sie einen Fehler gefunden oder einen Vorschlag? Lassen Sie es uns wissen!",
      submitSuccess: "Problem gemeldet",
      submitSuccessDesc: "Vielen Dank für Ihr Feedback. Wir werden uns damit befassen.",
      submitError: "Übermittlung fehlgeschlagen",
      submitErrorDesc: "Bei der Meldung Ihres Problems ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
      form: {
        titleLabel: "Titel",
        titlePlaceholder: "Kurze Beschreibung des Problems",
        descriptionLabel: "Beschreibung",
        descriptionPlaceholder: "Bitte geben Sie Details zum Problem an...",
        priorityLabel: "Priorität",
        priorityPlaceholder: "Priorität auswählen",
        priorityLow: "Niedrig",
        priorityMedium: "Mittel",
        priorityHigh: "Hoch",
        priorityDescription: "Wählen Sie die Dringlichkeit dieses Problems, um uns bei der richtigen Priorisierung zu helfen.",
        submit: "Problem melden",
        submitting: "Wird gesendet...",
        imagesLabel: "Bilder Anfügen (Optional)",
        typeLabel: "Art des Problems",
        typePlaceholder: "Art des Problems auswählen",
        typeBug: "Fehler",
        typeRequest: "Anfrage",
        typeDescription: "Art des Problems auswählen",
      },
      imageUpload: {
        dragDrop: "Ziehen Sie Bilder hierher",
        dropHere: "Hier Bilder ablegen...",
        clickToSelect: "oder klicken Sie, um Dateien auszuwählen",
        maxSize: "Max 5MB pro Datei",
        maxNumber: "Max 5 bilder",
        attachedImages: "Angehängte Bilder",
        invalidFiles: "Einige Dateien wurden nicht akzeptiert",
        sizeTypeLimit: "Dateien müssen Bilder unter 5MB sein",
        tooManyImages: "Zu viele Bilder",
        limitReached: "Sie können nur bis zu 5 Bilder anhängen",
        pasteSupported: "Einfügen von Bildern unterstützt",
        pasteSuccess: "Bild eingefügt",
        pasteSuccessDesc: "Bild aus der Zwischenablage wurde angehängt",
        pasteFailed: "Einfügen fehlgeschlagen",
        pasteFailedDesc: "Der Inhalt der Zwischenablage konnte nicht verarbeitet werden",
        processing: "Bild wird verarbeitet...",
      },
    }
  }
};
